import React from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import Btn from "../components/Btn";

type Props = { visible: boolean, onRequestClose: () => void, onConfirm: () => void };

const VerifyIdentityModal = (props: Props) => {
  const {visible} = props;

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onRequestClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Verify Identity</P>
                <FontAwesome5
                  name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                  onPress={props.onRequestClose}
                />
              </Div>

              <Div px={16} pb={24} pt={24} alignItems="center">
                <FontAwesome5 name="id-card" size={48} color="#00DAC8" style={MainStyle.m_b_10}/>

                <P fontFamily="DavisSans-Regular" ta="center" mb={30}>
                  Verify your identity now and receive an extra $10 in bonus cash!
                </P>

                <Btn bg="#3369FF" onPress={props.onConfirm} w="100%" mb={20}>
                  <P fontFamily="DavisSans-Medium" lh={56} ta="center">Verify Now</P>
                </Btn>
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default VerifyIdentityModal;
